<script>
    export let id;
    export let name;
    export let description;
    export let checked;
    export let disabled = false;
    export let onChange;
</script>

<fieldset name={id}>
    <input
            name="preset"
            type="checkbox"
            id={id}
            disabled={disabled}
            bind:checked={checked}
            on:change|preventDefault={()=>{
                onChange(checked);
            }}
    >
    <label class="switch" for={id}>{name}</label>
    <h3>{name}</h3>
    {#if description}
        <p>{@html description}</p>
    {/if}
    <section>
        <slot></slot>
    </section>
</fieldset>

<style>
    fieldset {
        margin-top: 6px;
        margin-bottom: 6px;
        border-width: 1px;
        border-style: solid;
    }

    input {
        display: none;
    }

    h3 {
        display: inline-block;
        font-size: 14px;
        line-height: 1.15;
        margin-top: .5em;
        margin-bottom: .5em;
        margin-left: .5em;
    }

    @media (max-width: 580px) {
        h3 {
            margin-top: .25em;
            margin-bottom: .25em;
        }
    }

    .switch {
        cursor: pointer;
        transition: .3s;
        position: relative;
        display: inline-block;
        vertical-align: middle;
        font-size: 0;
    }

    input[disabled],
    input[disabled] + .switch {
        opacity: .5;
        cursor: not-allowed;
    }

    /* THEME: bottom */
    :global(.e_consent.e_consent--theme-bottom fieldset) {
        padding: .3rem;
    }

    :global(.e_consent.e_consent--theme-bottom .switch) {
        background-color: #ccc;
        border-radius: 12px;
        transition: .3s;
        width: 39px;
        height: 20px;
    }

    :global(.e_consent.e_consent--theme-bottom .switch:before) {
        position: absolute;
        content: 'off';
        padding-left: 4px;
        padding-right: 4px;
        height: 16px;;
        width: 24px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        border-radius: 16px;
        transition: .3s;
        text-align: center;
        font-size: 12px;
        vertical-align: center;
        line-height: 16px;
        font-weight: bold;
    }


    :global(.e_consent.e_consent--theme-bottom input:checked + .switch:before) {
        content: 'on';
        transform: translateX(11px);
    }

    /* THEME: overlay */
    :global(.e_consent.e_consent--theme-overlay fieldset) {
        padding: 0;
        border: 0 !important;
        margin-right: 1rem;
        flex-grow: 1;
    }

    :global(.e_consent.e_consent--theme-overlay h3) {
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        color: #000036;
        margin-left: .33em;
    }

    :global(.e_consent.e_consent--theme-overlay fieldset:last-of-type) {
        margin-right: 0;
    }

    :global(.e_consent.e_consent--theme-overlay .switch) {
        background-color: white;
        width: 20px;
        height: 20px;
        border-radius: 4px;
        border: 2px solid #05164d;
        margin-top: -6px;
        margin-bottom: 0;
    }

    :global(.e_consent.e_consent--theme-overlay .switch:before) {
        content: '';
        position: absolute;
        display: block;
        left: 6px;
        top: 2px;
        width: 5px;
        height: 10px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        box-sizing: inherit;
    }

    :global(.e_consent.e_consent--theme-overlay input:checked + .switch) {
        background-color: #05164d;
    }

    :global(.e_consent.e_consent--theme-overlay input:checked + .switch:before) {
        content: '';
        z-index: 1;
    }
</style>
